<!-- //
通道监控服务列表
@auth xuyd
@date 2025-9-2
//-->
<template>
  <page-layout layout="C">
    <div class="layout-search">
      <div class="flex-row flex-halign-between">
        <div class="flex-column form">
          <el-row class="item">
            <span class="title blob">{{ form.serverName }}</span>
            <span class="title blob">{{ form.serverIp }}</span>
          </el-row>
          <el-row class="item">
            <span class="title">日志路径：</span>
            <span class="value">{{ form.logPath }}</span>
          </el-row>
          <el-row class="item">
            <span class="title">探活逻辑：</span>
            <span class="value">{{ form.monitorLogicDesc }}</span>
          </el-row>
        </div>
        <div>
          <el-button size="small" type="primary" plain @click="$router.back();">返 回</el-button>
        </div>
      </div>
    </div>

    <div class="layout-search">
      <div class="flex-row flex-halign-between">
        <el-form :model="queryParams" ref="queryForm" :inline="true" size="small" @submit.native.prevent>
          <el-row class="mt10">
            <el-form-item label="" prop="date">
              <el-date-picker
                  v-model="queryParams.date"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetimerange"
                  style="width: 400px">
              </el-date-picker>

            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
              <el-button size="small" icon="el-icon-refresh" @click="handleReset">重置</el-button>
            </el-form-item>
          </el-row>
        </el-form>
        <div class="flex-row flex-valign-center">
          <div>
            <el-button size="small" type="primary" @click="handleExport">导出</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="layout-result" style="height: calc(100% - 125px - 60px)">
      <DynamicTable :query-params="queryParams"
                    :data="tableData"
                    :metas="tableMetas"
                    @reload="getList">
      </DynamicTable>
    </div>
  </page-layout>
</template>
<script>
import MonitorChannelApi from '@/api/sys/sysMonitorChannel.api.js';

export default {
  name: 'ViewMonitorTaskList',
  components: {},
  dictTypes: [
    {dictType: 'HEALTHY_STATUS', dataType: Number}, // 健康状态
  ],
  data() {
    return {
      loading: false,
      form: {
        id: null,
        serverName: null,
        serverIp: null,
        logPath: null,
        monitorLogicDesc: null,
        monitorParamsScript: null,
      },
      // 查询变量
      queryParams: {
        pageNum: 1,
        pageSize: 20,
        orderByColumn: null,
        isAsc: null,

        mainId: null,
        startTime: null,
        endTime: null,
        monitorStatus: [],
      },
      tableData: {
        tableLoading: false,
        records: [],
        total: 0,
      },
      // table字段配置
      tableMetas: [
        {
          prop: "monitorTime", label: "探活起止时间", width: 320, dataType: "custom",
          funcRender: (h, params) => {
            return [h("span", params.row.monitorStartTime + "~" + params.row.monitorEndTime)];
          },
        },
        {
          prop: 'monitorStatus', label: "健康状态", width: 100, dataType: 'dict', dictType: 'HEALTHY_STATUS',
          filterable: true, filterComp: 'FunnelMultiSelect'
        },
        {prop: "monitorResult", label: "探查结果", minWidth: 300},
      ],
    };
  },
  created() {
    this.form.id = this.$route.query.id;
    this.queryParams.mainId = this.$route.query.id;
    this.getInfo();
    this.getList();
  },
  methods: {
    /** 查询列表 */
    getInfo() {
      MonitorChannelApi.queryMonitorInfo(this.form.id).then(resp => {
        this.form = resp.data
      });
    },

    /** 查询列表 */
    getList() {
      this.loading = true;
      if (this.queryParams.date && this.queryParams.date.length > 0) {
        // this.queryParams.startTime = this.$util.timestampM2s(this.queryParams.date[0]);
        // this.queryParams.endTime = this.$util.timestampM2sEnd(this.queryParams.date[1]);
        this.queryParams.startTime = this.queryParams.date[0];
        this.queryParams.endTime = this.queryParams.date[1];
      } else {
        this.queryParams.startTime = null;
        this.queryParams.endTime = null;
      }
      MonitorChannelApi.searchMonitorTaskList(this.queryParams).then(resp => {
        this.tableData.records = resp.data.records;
        this.tableData.total = resp.data.total;
        this.loading = false;
      }).catch(err => {
        this.loading = false;
      });
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },

    /** 排序触发事件 */
    handleSortChange(column, prop, order) {
      this.queryParams.orderByColumn = column.prop;
      this.queryParams.isAsc = column.order;
      this.getList();
    },

    /**
     * 重置按钮事件
     */
    handleReset() {
      this.resetForm("queryForm");
      this.$refs.queryForm.resetFields();
      this.queryParams.date = [];
      this.queryParams.monitorStatus = [];

      this.queryParams.orderByColumn = null;
      this.queryParams.isAsc = null;
      this.handleQuery();
    },
    /** 导出 */
    handleExport() {
      MonitorChannelApi.exportTaskList(this.queryParams);
    },

  },
};
</script>

<style lang="less" scoped>
.form {
  .item {
    padding-bottom: 10px;
  }

  .title {
    padding-left: 10px;
  }

  .blob {
    font-weight: 700;
  }

  .value {
    padding-left: 10px;
    color: #606266
  }
}
</style>

